import { computed, Ref } from 'vue';
import { ScanningStatusEnum } from '../enums/scanningStatus.enum';
import i18n from '../locales/i18n';
import { BaseFile } from '../types';

export const useAvatarScan = (file: Ref<BaseFile | null>, textLength: 'short' | 'long' = 'long') => {
  const scanningText = computed(() => {
    if (!file.value) {
      return null;
    }

    const scanningStatus = file.value.scanningStatus;

    if (scanningStatus === ScanningStatusEnum.PROCESSING) {
      if (textLength === 'short') {
        return i18n.t('file.file_scan_processing_image_short');
      } else {
        return i18n.t('file.file_scan_processing_image');
      }
    }

    if (scanningStatus === ScanningStatusEnum.BLOCKED) {
      if (textLength === 'short') {
        return i18n.t('file.file_scan_blocked_short');
      } else {
        return i18n.t('file.file_scan_blocked_image');
      }
    }
    return null;
  });

  const isFileDisabled = computed(() => {
    if (!file.value) {
      return false;
    }

    const scanningStatus = file.value.scanningStatus;
    return scanningStatus === ScanningStatusEnum.PROCESSING || scanningStatus === ScanningStatusEnum.BLOCKED;
  });

  return {
    scanningText,
    isFileDisabled,
  };
};
